import type { BoxHoehe, FifoRichtung } from '../api/typen'

/** Was sich an einem Fach oder einer Sonderfall-Ebene beschreiben laesst. */
export interface Bestueckung {
  waagen: string[]
  boxHoehe: BoxHoehe | null
  fifo: boolean
  fifoRichtung: FifoRichtung | null
}

/** Einzeilige Kurzform, etwa "15 × 50 + 15 × 50 · Box H8 · FiFo längs". */
export function beschreibe(bestueckung: Bestueckung): string {
  const waagen = bestueckung.waagen.map((waage) => waage.replace('x', ' × ')).join(' + ') || 'keine Waage'
  const fifo = bestueckung.fifo
    ? `FiFo ${bestueckung.fifoRichtung === 'laengs' ? 'längs' : 'quer'}`
    : 'kein FiFo'
  const box = bestueckung.boxHoehe === 'OHNE' ? 'ohne Box' : `Box ${bestueckung.boxHoehe ?? '–'}`
  return `${waagen} · ${box} · ${fifo}`
}

/** Eine Sonderfall-Ebene gilt als zugeordnet, sobald Waage oder Box gesetzt sind. */
export function istZugeordnet(bestueckung: Bestueckung): boolean {
  return bestueckung.waagen.length > 0 || bestueckung.boxHoehe !== null
}

/** Anzeigename eines Fachs: die Nummer bleibt immer sichtbar, die Bezeichnung kommt dazu. */
export function fachName(fach: { fachNr: number; bezeichnung: string | null }): string {
  return fach.bezeichnung ? `Fach ${fach.fachNr} · ${fach.bezeichnung}` : `Fach ${fach.fachNr}`
}
